import { render, staticRenderFns } from "./number-selector.vue?vue&type=template&id=60fa8c31"
import script from "./number-selector.vue?vue&type=script&lang=ts"
export * from "./number-selector.vue?vue&type=script&lang=ts"
import style0 from "./number-selector.vue?vue&type=style&index=0&id=60fa8c31&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports